










# import settings from '@/settings'
import oncall_duties_table from '@/components/tables/oncall_duties_table'

export default {
    name: 'users_oncall_duties'

    components: { oncall_duties_table }
}

